import type { ReactNode } from "react";
import type { AppRole } from "@vimos/api-client";
import { useAuth } from "../lib/auth";
import { LoginPage } from "./LoginPage";

interface Props {
  children: ReactNode;
  requiredRoles?: AppRole[];
}

export function ProtectedRoute({ children, requiredRoles }: Props) {
  const { session, profile, isLoading } = useAuth();

  if (isLoading) {
    return <div className="text-mist flex min-h-screen items-center justify-center">Cargando…</div>;
  }

  if (!session) {
    return <LoginPage />;
  }

  if (requiredRoles && (!profile || !requiredRoles.includes(profile.role))) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-2 text-center">
        <p className="font-display text-ink text-xl font-semibold">Acceso restringido</p>
        <p className="text-mist">Tu rol actual no tiene permiso para ver esta sección.</p>
      </div>
    );
  }

  return <>{children}</>;
}
